import { render, staticRenderFns } from "./clientStatementinfo.vue?vue&type=template&id=75080543&scoped=true&"
import script from "./clientStatementinfo.vue?vue&type=script&lang=js&"
export * from "./clientStatementinfo.vue?vue&type=script&lang=js&"
import style0 from "./clientStatementinfo.vue?vue&type=style&index=0&id=75080543&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75080543",
  null
  
)

export default component.exports